import React, { Dispatch } from 'react'

import NationalResultTable from './National/NationalResultTable'
import RegionalResultTable from './Regional/RegionalResultTable'
import ProvincialResultTable from './Provincial/ProvincialResultTable'
import { resultForKey } from '../../controllers/DataController'
import RidingResultTable from './Riding/RidingResultTable'
import { IPartyNumberMap } from '../../models/TypeHelper'

import TabInterface from '../Tabs/TabInterface'
import Tab from '../Tabs/Tab'
import { connect } from 'react-redux'
import { IReduxAction, IReduxState } from '../../utils/ReduxStore'

import './TabularResults.scss'

export interface IRegionalPollMap {
  [key: string]: IPartyNumberMap
}

interface IDispatchProps {
  initialized: () => void
}

interface IStateProps {
  compareResultKey: string
}

interface IProps extends IDispatchProps, IStateProps {}

class App extends React.Component<IProps> {
  public render(): JSX.Element {
    const nationalResult = resultForKey(this.props.compareResultKey)

    return (
      <div className="row mt-3 TabularResults">
        <div className="col">
          <TabInterface defaultTab={'national'}>
            <Tab key="national" name="National">
              <NationalResultTable nationalResult={nationalResult} />
            </Tab>
            <Tab key="regional" name="Regional">
              <RegionalResultTable nationalResult={nationalResult} />
            </Tab>
            <Tab key="provincial" name="Provincial">
              <ProvincialResultTable nationalResult={nationalResult} />
            </Tab>
            <Tab key="ridings" name="Ridings">
              <RidingResultTable nationalResult={nationalResult} />
            </Tab>
          </TabInterface>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state: IReduxState): IStateProps => ({
  compareResultKey: state.compareResultKey
})

const mapDispatchToProps = (
  dispatch: Dispatch<IReduxAction>
): IDispatchProps => ({
  initialized: (): void => {
    dispatch({ type: 'INITIALIZED' })
  }
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App)
